module.exports = __webpack_public_path__ + "img/return.6ff16ef6.svg";